import { authService } from '../services/authService.js';
import { element, showMessage } from '../components/publicUi.js';

export const accountRoutes = ['forgot-password', 'resend-verification', 'verify-email', 'reset-password', 'change-password', 'recover-mfa'];
export function readAccountLink(hash, clearAddress) {
  const [route, query = ''] = hash.replace(/^#\/?/, '').split('?');
  if (!accountRoutes.includes(route)) return null;
  const params = new URLSearchParams(query);
  const values = params.getAll('token');
  const token = values.length === 1 && /^[a-f0-9]{64}$/.test(values[0]) ? values[0] : null;
  if (query) clearAddress(`#${route}`);
  return { route, token };
}

export class RecoveryPage {
  constructor(action, token, service = authService) { this.action = action; this.token = token; this.service = service; }
  render() {
    const titles = { 'forgot-password': 'Восстановление пароля', 'resend-verification': 'Повторное подтверждение email', 'verify-email': 'Подтверждение email', 'reset-password': 'Новый пароль', 'change-password': 'Смена пароля' };
    const page = element('div', 'container page-wrapper'), box = element('section', 'spec-box glow-box');
    box.style.maxWidth = '600px'; box.style.margin = '0 auto';
    box.append(element('h1', 'spec-title', this.action === 'recover-mfa' ? 'Восстановить без почты' : titles[this.action]));
    this.feedback = element('div', 'public-message'); this.feedback.setAttribute('role', 'status');
    const needsToken = ['verify-email', 'reset-password'].includes(this.action);
    const change = this.action === 'change-password';
    const offline = this.action === 'recover-mfa';
    if (change && !this.service.getCurrentUser()) {
      showMessage(this.feedback, this.service.getState().status === 'error' ? 'Не удалось проверить сессию. Обновите страницу.' : 'Для смены пароля войдите в аккаунт.');
    } else if (needsToken && !this.token) {
      showMessage(this.feedback, 'Ссылка неполная или уже закрыта. Откройте ссылку из письма либо запросите новую.');
    } else {
      const form = element('form'); this.form = form;
      if (!needsToken && !change && !offline) this.input(form, 'email', 'Email', 'email', { maxLength: 254, autocomplete: 'email' });
      if (offline) {
        form.append(element('p', 'profile-text', 'Нужны подключённый аутентификатор и один сохранённый резервный код. Если потеряны оба, обратитесь к владельцу сервера.'));
        this.input(form, 'identifier', 'Логин или email', 'text', { maxLength: 254, autocomplete: 'username' });
        this.input(form, 'recoveryCode', 'Резервный код', 'text', { maxLength: 64, autocomplete: 'off' });
      }
      if (change) {
        form.append(element('p', 'profile-text', 'После смены пароля потребуется повторный вход на всех устройствах.'));
        this.input(form, 'currentPassword', 'Текущий пароль', 'password', { maxLength: 128, autocomplete: 'current-password' });
      }
      if (this.action === 'reset-password' || change || offline) {
        this.input(form, 'password', 'Новый пароль (12–128 символов)', 'password', { minLength: 12, maxLength: 128, autocomplete: 'new-password' });
        this.input(form, 'confirmation', 'Повторите новый пароль', 'password', { minLength: 12, maxLength: 128, autocomplete: 'new-password' });
        this.input(form, 'factor', offline ? 'Шестизначный код' : 'Код аутентификатора или резервный код', 'text', { maxLength: 64, autocomplete: 'one-time-code', required: offline || Boolean(this.service.getCurrentUser?.()?.mfaEnabled) });
      }
      if (this.action === 'verify-email') form.append(element('p', 'profile-text', 'Нажмите кнопку, чтобы подтвердить email по ссылке из письма.'));
      const submit = element('button', 'auth-submit-btn auth-submit-login', needsToken || change || offline ? (this.action === 'verify-email' ? 'Подтвердить email' : 'Сохранить новый пароль') : 'Отправить письмо'); submit.type = 'submit';
      form.append(submit); form.addEventListener('submit', event => { event.preventDefault(); void this.submit(); }); box.append(form);
    }
    box.append(this.feedback);
    const links = element('div', 'recovery-links');
    if (this.action === 'forgot-password') { const offlineLink = element('a', 'profile-link', 'Восстановить без почты'); offlineLink.href = '#recover-mfa'; links.append(offlineLink); }
    const link = element('a', 'profile-link', 'Запросить новое письмо'); link.href = this.action.includes('password') ? '#forgot-password' : '#resend-verification';
    if (needsToken) links.append(link);
    const home = element('a', 'profile-link', 'На главную'); home.href = '#home'; links.append(home); box.append(links); page.append(box); return page;
  }
  input(form, name, label, type, options) {
    const group = element('div', 'auth-form-group'), caption = element('label', 'auth-form-label', label), input = element('input', 'auth-input');
    input.id = `recovery-${name}`; input.name = name; input.type = type; input.required = true;
    Object.assign(input, options); caption.htmlFor = input.id; group.append(caption, input); form.append(group);
  }
  async submit() {
    if (this.busy || this.disposed || !this.form?.isConnected) return;
    const value = name => this.form.querySelector(`[name="${name}"]`)?.value;
    const change = this.action === 'change-password';
    const offline = this.action === 'recover-mfa';
    const body = offline ? { identifier: value('identifier').trim(), recoveryCode: value('recoveryCode').trim() } : change ? { currentPassword: value('currentPassword') } : this.token ? { token: this.token } : { email: value('email').trim() };
    if (this.action === 'reset-password' || change || offline) {
      if (value('password') !== value('confirmation')) { showMessage(this.feedback, 'Пароли не совпадают.'); return; }
      body.password = value('password');
      if (value('factor')?.trim()) body.factor = value('factor').trim();
    }
    this.busy = true; const controls = [...this.form.querySelectorAll('button,input')]; controls.forEach(control => { control.disabled = true; });
    showMessage(this.feedback, 'Ожидание ответа сервера…');
    try {
      if (offline) await this.service.recoverMfa(body);
      else await this.service.accountAction(this.action, body);
      if (this.disposed) return;
      this.token = null; this.form.remove();
      showMessage(this.feedback, this.action === 'reset-password' || change || offline ? 'Пароль изменён. Все прежние сессии завершены. Войдите с новым паролем.'
        : this.action === 'verify-email' ? 'Email подтверждён.' : 'Если адрес подходит для этого действия, письмо будет отправлено. Проверьте почту.');
      if (this.action === 'verify-email') void this.service.refresh();
    } catch (error) {
      if (!this.disposed) showMessage(this.feedback, error.message);
      if (error.code === 'INVALID_TOKEN') { this.token = null; this.form.remove(); }
      if (change && error.code === 'UNAUTHENTICATED') this.form.remove();
    } finally {
      this.busy = false; controls.forEach(control => { control.disabled = false; if (control.type === 'password') control.value = ''; });
    }
  }
  dispose() { this.disposed = true; this.token = null; this.form?.querySelectorAll('input').forEach(input => { input.value = ''; }); }
}
